import React from 'react'
import { Grid, Typography } from '@mui/material'
import useStyles from './Style'
import Image from 'next/image'
import clsx from 'clsx'
interface IProps {
  content: {
    img: string
    name: string
    designation: string
    description: string
  }
  zenMode: boolean
}
const ImgCard: React.FC<IProps> = ({ content, zenMode }) => {
  const { classes } = useStyles()

  return (
    <Grid
      className={clsx(
        classes.rootContainer,
        zenMode && classes.zenModeCardContainer
      )}
      container
    >
      <Grid
        item
        md={12}
        sm={12}
        xs={5}
        className={classes.imgContainer}
        sx={{ display: zenMode ? 'none' : 'flex' }}
      >
        <Image alt="" src={content.img} fill />
      </Grid>
      <Grid item md={12} sm={12} xs={zenMode ? 12 : 6}>
        <Typography className={classes.primaryHeading}>
          {content.name}
        </Typography>
        <Typography className={classes.secondaryHeading}>
          {content.designation}
        </Typography>
        <Typography className={classes.text}>{content.description}</Typography>
      </Grid>
    </Grid>
  )
}

export default ImgCard
